// src/reducers/slice/exportProgressSlice.js
import { createSlice } from '@reduxjs/toolkit';

const exportProgressSlice = createSlice({
  name: 'exportProgress',
  initialState: { jobs: [] },
  reducers: {
    startExportProgress: (state, action) => {
      const { id, name, type } = action.payload;
      state.jobs.unshift({
        id,
        name,
        type: type || 'Export',
        status: 'in-progress',
        step: 'Preparing',
        percent: null,
        loadedBytes: null,
        totalBytes: null,
        fileName: null,
        downloadUrl: null,
        reportUrl: null,
        error: null,
        startedAt: Date.now(),
        finishedAt: null,
      });
    },
    updateExportProgress: (state, action) => {
      const { id, percent, loadedBytes, totalBytes } = action.payload;
      const job = state.jobs.find((j) => j.id === id);
      if (job) {
        job.step = 'Downloading';
        job.percent = percent;
        job.loadedBytes = loadedBytes;
        job.totalBytes = totalBytes;
      }
    },
    completeExportProgress: (state, action) => {
      const { id, fileName, downloadUrl, totalBytes, reportUrl } = action.payload;
      const job = state.jobs.find((j) => j.id === id);
      if (job) {
        job.status = 'completed';
        job.step = 'Completed';
        job.percent = 100;
        job.fileName = fileName;
        job.downloadUrl = downloadUrl || null;
        job.reportUrl = reportUrl || null;
        job.totalBytes = totalBytes;
        job.finishedAt = Date.now();
      }
    },
    failExportProgress: (state, action) => {
      const { id, error } = action.payload;
      const job = state.jobs.find((j) => j.id === id);
      if (job) {
        job.status = 'failed';
        job.step = 'Failed';
        job.error = error || 'Something went wrong. Please try again.';
        job.finishedAt = Date.now();
      }
    },
    cancelExportProgress: (state, action) => {
      const { id } = action.payload;
      const job = state.jobs.find((j) => j.id === id);
      if (job) {
        job.status = 'cancelled';
        job.step = 'Cancelled';
        job.finishedAt = Date.now();
      }
    },
  },
});

export const {
  startExportProgress,
  updateExportProgress,
  completeExportProgress,
  failExportProgress,
  cancelExportProgress,
} = exportProgressSlice.actions;
export const exportProgressReducer = exportProgressSlice.reducer;
export default exportProgressSlice;
